import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_do_not_give_written_consent_monies_be'

export const dataPointDefinition = {
  retracedId: 'workers_do_not_give_written_consent_monies_be',
  name: 'Workers do not give written consent for monies to be deducted (signing a document in a language they understand)',
  description:
    'The intent of this question is to understand if workers sign a document (in a language they understand) giving consent for monies (other than those that are legally required) to be deducted.',
  meta: {
    slcpMeta: {
      key: 'wb-wage-101x',
      number: 'WB-WAGE-121-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-101x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35910,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
